import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/productResidues',
  component: Layout,
  name: 'productResidues',
  redirect: '/productResidues/index',
  children: [{
    path: '/productResidues/index:id',
    component: () => import('@/views/productResidues/index'),
    name: 'productResidues.index',
    meta: {
      title: i18n.t('message.nurse_office')
    }
  }, ]
}

export default schedule